exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noPadding{padding-left:0; padding-right:0;}\n.txtBoxRepeat .txtBox .custom-ctrl{margin-bottom: 0;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/calculator-dialog/calculator-dialog.component.css
// module id = ../../../../../src/app/pages/calculator-dialog/calculator-dialog.component.css
// module chunks = main